import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { getAddressFromCinAction } from "../action/getAddressFromCinAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const addressFromCinSlice = createSlice({
  name: "addressFromCinSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAddressFromCinAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAddressFromCinAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAddressFromCinAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const addressFromCinReducer = addressFromCinSlice.reducer;
